export class FreteFaixa {
  id: number;
  de: number;
  ate: number;
}
